import React from 'react'

export default function ModalFloat({ children }) {
    return (
        <>
            <div
                id="my-modal"
                className="uk-flex-top uk-flex uk-open "
                uk-modal={1}
            >
                <div  className="uk-border-rounded uk-modal-dialog uk-text-center uk-margin-top">
                    {children}
                </div>
            </div>
        </>
    )
}
